<template>
	<div class="w_grid-000" data-tmpleditable="editable" style="margin-top: 130px;">
		<!-- <div class="news_header"></div> -->
		<div class="news-header">
			<div>新闻资讯</div>
			<div style="display: flex;flex-direction: row;font-weight: normal;">
				<div class="line"></div>
				<div class="title" style="font-size: 18px;padding: 0 15px;">Social Responsibility</div>
				<div class="line"></div>
			</div>
			<!-- 新闻 -->
			<div class="news_title">
				{{ item.title }}
			</div>
			<div class="news_autor">
				<div style="margin-right: 30px;">来源：{{ item.autor }} </div>
				<div>发布时间：{{ formattedTime }}</div>
			</div>

			<div v-html="item.content"
				style="margin-top: 20px;font-weight:normal;font-size: 20px;padding: 0 200px;justify-content: center;align-items: center;">
			</div>
			<button class="back-btn" @click="goBack">
				<i class="fas fa-arrow-left"></i> 返回列表
			</button>
		</div>
	</div>

</template>
<script>
export default {
	data() {
		return {
			item: {}
		}
	},
	mounted() {
		// console.log('路由参数:', this.$route.params);
		this.item = this.$route.params;

	},
	computed: {
		formattedTime() {
			const createTime = this.item.createTime;
			if (!createTime) {
				return '时间未知';
			}
			const date = new Date(createTime);
			if (isNaN(date.getTime())) {
				return '时间格式错误';
			}
			const year = date.getFullYear();
			const month = (date.getMonth() + 1).toString().padStart(2, '0');
			const day = date.getDate().toString().padStart(2, '0');
			const hour = date.getHours().toString().padStart(2, '0');
			const minute = date.getMinutes().toString().padStart(2, '0');
			return `${year}-${month}-${day} ${hour}:${minute}`;
		}
	},
	methods: {
		goBack() {
			this.$router.go(-1);
		}
	}
}
</script>
<style scoped lang="scss">
// .news_header {
// 	width: 100%;
// 	height: 520px;
// 	background: url(../assets/furuiImg/news.jpg);
// 	background-size: cover;
// 	background-position: center;
// 	// margin-bottom: 50px;
// 	// margin-top: 80px;
// }

.line {
	flex: 1;
	height: 2px;
	background: #000;
	width: 50px;
	align-items: center;
	display: flex;
	margin-top: 12px;
}

.news-header {
	width: 100%;
	height: 100%;
	display: flex;
	flex-direction: column;
	justify-content: center;
	align-items: center;
	// margin-top: 100px;
	font-size: 25px;
	font-weight: bold;
	color: black;
	padding: 100px 100px;
}

.news_autor {
	font-weight: normal;
	font-size: 16px;
	color: #666666;
	display: flex;
	flex-direction: row;
}

// 返回按钮样式
.back-btn {
	background-color: #f0f0f0;
	border: none;
	padding: 8px 16px;
	border-radius: 4px;
	cursor: pointer;
	font-size: 16px;
	display: flex;
	align-items: center;
	transition: all 0.3s ease;
	margin-top: 100px;

	&:hover {
		background-color: #66B782;
		color: white;
		transform: translateX(-3px);
	}

	i {
		margin-right: 6px;
	}
}
</style>